const BODY_MAX = 100;

/** One-line preview for an inbound chat message (matches push copy). */
export function messagePreview(message: {
  content?: string | null;
  mediaType?: string | null;
} | null | undefined): string {
  const raw = String(message?.content || '')
    .replace(/\s+/g, ' ')
    .trim();
  if (raw) {
    if (raw.length > BODY_MAX) return `${raw.slice(0, BODY_MAX).trimEnd()}...`;
    return raw;
  }
  const mt = String(message?.mediaType || '').toLowerCase();
  if (mt === 'image' || mt.startsWith('image/')) return 'Photo';
  if (mt === 'video' || mt.startsWith('video/')) return 'Video';
  return 'New message';
}

export function senderName(sender: {
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
} | null | undefined): string {
  const name = [sender?.firstName, sender?.lastName].filter(Boolean).join(' ').trim();
  return name || sender?.username || 'Ompli';
}
